import { getThemeConfig, getThemeColours } from "./invariantMessAggregator";
import { getSLConfig } from "./statelegAggregators";


export function getExampleClientColours() {
  return [
    ...getThemeColours(),
    "#5B8DB8",
    "#7FA7C9",
    "#96C5C3",
    "#E59E6D",
    "#C86B5A",
    "#8C9BA5",
    "#B5BFC7",
  ];
}

export function getExampleClientConfig() {
  const { groupsById: themeGroups } = getThemeConfig();
  const { groupsById: stateLegGroups } = getSLConfig();

  return {
    groupsById: {
      ...themeGroups,
      trust_institutions: {
        ...stateLegGroups.trust_institutions,
        label: "Trusted institutions on healthcare issues",
        colors: {
          trust_docs_pred: "#0F766E",
          trust_hospitals_pred: "#2563EB",
          trust_stategov_pred: "#7C3AED",
          trust_fedgov_pred: "#DC2626",
          trust_pharmaorgs_pred: "#EA580C",
          trust_healthInsurance_pred: "#475569",
          trust_none_pred: "#94A3B8",
        },
      },
    },
  };
}

// Tab-as-config default export
export default {
  tab: "example_client",
  label: "Example Client",
  get metrics() { return getExampleClientConfig().groupsById; },
};
